import { oz } from '@weft/utils';

export const PaginationMetadataSchema = oz.object({
  total: oz.number(),
  hasMore: oz.boolean(),
  nextCursor: oz.string().optional(),
});

export type PaginationMetadata = oz.infer<typeof PaginationMetadataSchema>;